import { Button, Input } from "antd";
import { useContext, useState } from "react";
import "./CreateFolderModal.scss";
import LocationsApi from "../../api/LocationsApi";
import { AppContext } from "../../AppContext";
import DesignApi from "../../api/DesignApi";
import { MenuFolderDto } from "../../generated/dashboard-client";
import FolderIcon from "../icons/FolderIcon";

export interface CreateFolderContentProps {
  ids: string[];
  onClose: (ids: string[], folderToMove?: MenuFolderDto | null, folder?: MenuFolderDto, parentFolder?: MenuFolderDto | null) => void;
  folderToMove: MenuFolderDto | null,
  parentFolder: MenuFolderDto | null,
  folderNameExists: (folder: MenuFolderDto | null, name: string) => boolean | undefined;
}

export function CreateFolderContent({
  ids,
  onClose,
  folderToMove,
  parentFolder,
  folderNameExists
}: CreateFolderContentProps) {
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);
  const { location } = useContext(AppContext);

  async function save() {
    setSaving(true);

    if (folderNameExists(null, name)) {
      setSaving(false);
      return;
    }

    try {
      const { data } = await LocationsApi.createLocationFolder(
        location.internalId!,
        name
      );

      if (folderToMove) {
        await DesignApi.putFolderInFolder(folderToMove.id!, data.id!);
      } else if (ids.length > 0) {
        await DesignApi.putInFolder(ids, data.id!);
      }

      if (parentFolder) {
        await DesignApi.putFolderInFolder(data.id!, parentFolder.id!);
      }

      setSaving(false);
      onClose(ids, folderToMove, data, parentFolder);
    } catch (err) {
      setSaving(false);
    }
  }

  return (<div>
      <header>
        <FolderIcon />
        <h2>Create New Folder</h2>
      </header>

      <div className={"input-cont"}>
        <Input
          value={name}
          onChange={(ev) => setName(ev.target.value)}
          size={"large"}
          placeholder={"Enter a folder name"}
        />
      </div>

      <footer>
        <Button size={"large"} onClick={() => onClose([])}>
          Cancel
        </Button>
        <Button
          size={"large"}
          className={"primary"}
          onClick={save}
          loading={saving}
          disabled={!name}
        >
          Create
        </Button>
      </footer>
    </div>
  );
}
